export default __webpack_public_path__ + "static/media/background.7cb96e9a.png";